import { Typography, TypographyProps, useTheme } from '@mui/material';
import { memo } from 'react';
import { Trans } from 'react-i18next';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';

import { Hyperlink } from '../Form/Form.styled';

type PolicyFooterProps = {
  countryCode: string;
} & TypographyProps;

export const CaymanPolicyFooter = memo(function CaymanPolicyFooter({
  countryCode,
  ...props
}: PolicyFooterProps) {
  const { translateIfExists, policyByCountry } = useTranslate();
  const { links } = useAppSelector(selectConfigsState);
  const countryName = policyByCountry[countryCode];
  const theme = useTheme();

  return (
    <Typography
      variant="caption"
      color={theme.palette.text.secondary}
      {...props}
    >
      <Trans
        i18nKey="login.tocDescription"
        components={{
          a1: (
            <Hyperlink href={links?.privacyPolicyURL}>
              {translateIfExists('common.countryPrivacyPolicy', {
                country: countryName,
              })}
            </Hyperlink>
          ),
          a2: (
            <Hyperlink href={links?.termsAndConditionsURL}>
              {translateIfExists('common.countryTermsAndConditions', {
                country: countryName,
              })}
            </Hyperlink>
          ),
          a3: (
            <Hyperlink href={links?.biometricConsentURL}>
              {translateIfExists('common.biometricConsentText', {
                country: countryName,
              })}
            </Hyperlink>
          ),
          a4: (
            <Hyperlink href={links?.accountOpeningRequirementUrl}>
              <Trans
                i18nKey="common.accountOpeningRequirements"
                components={{ i: <i /> }}
              />
            </Hyperlink>
          ),
        }}
      />
    </Typography>
  );
});
